import { applyCartFragments } from '../utils/cart-fragments.js'

document.addEventListener('alpine:init', () => {
	window.Alpine.data('addToCart', () => ({
		state: null,

		init() {},

		submit(event) {
			event.preventDefault()

			const form = this.$el.closest('form')
			const variationIdInput = form.querySelector('input[name="variation_id"]')

			if (variationIdInput && Number(variationIdInput.value) === 0) {
				/* global wc_add_to_cart_variation_params */
				alert(wc_add_to_cart_variation_params.i18n_make_a_selection_text)

				return
			}

			if (
				document.body.classList.contains('woocommerce-cart')
				|| (variationIdInput && Number(variationIdInput.value) > 0)
			) {
				form.submit()
				return
			}

			const quantityWrapper = form.querySelector("[x-data='quantityInput']")
			const quantityInput = quantityWrapper.querySelector(
				'select[name], input[name]',
			)
			const quantity = quantityInput.value

			const formData = new FormData()
			formData.append('quantity', quantity)

			for (const key in this.$el.dataset) {
				formData.append(
					key.replace(/([A-Z])/g, (g) => `-${g[0].toLowerCase()}`),
					this.$el.dataset[key],
				)
			}

			this.state = 'loading'
			fetch('/?wc-ajax=add_to_cart', {
				method: 'POST',
				body: formData,
			})
				.then((response) => response.json())
				.then((data) => {
					if (data.error && data.product_url) {
						window.location = data.product_url
						return
					}

					applyCartFragments(data.fragments)

					this.state = 'success'
					this.$nextTick(() => this.$dispatch('cart-updated'))

					setTimeout(() => {
						this.state = null
					}, 2000)
				})
				.catch(() => {
					this.state = null
				})
		},
	}))
})
